import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ConflictedAnnexesDto } from 'src/app/models/dtos/annexes/conflicted-annexes-dto';

export interface ConflictedAnnexesDialogData {
  conflicts: ConflictedAnnexesDto[];
  currentChanges: CurrentChangesEntry;
}

export interface CurrentChangesEntry {
  AnnexStartDate: Date;
  AnnexEndDate: Date | null;
  ChangesJobTitle: boolean;
  ChangesTemporaryWorkplace: boolean;
  ChangesWage: boolean;
  ChangesSupervisor: boolean;
  ChangesWorkingTimeGroup: boolean;
}

export interface ConflictGroup {
  componentName: string;
  conflictingAnnexes: ConflictedAnnexesDto[];
}

@Component({
  selector: 'app-conflicted-annex-dialog',
  templateUrl: './conflicted-annex-dialog-component.html',
  styleUrl: './conflicted-annex-dialog-component.scss',
  standalone: false,
})
export class ConflictedAnnexDialogComponent {
  isConfirmed = false;
  conflictGroups: ConflictGroup[] = [];
  data = inject<ConflictedAnnexesDialogData>(MAT_DIALOG_DATA);

  private dialogRef = inject<MatDialogRef<ConflictedAnnexDialogComponent>>(MatDialogRef);

  constructor() {
    this.groupConflictsByComponent();
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }

  onConfirm(): void {
    this.dialogRef.close(true);
  }

  private groupConflictsByComponent(): void {
    const componentMap = new Map<string, ConflictedAnnexesDto[]>();

    this.data.conflicts.forEach((conflict) => {
      if (this.data.currentChanges.ChangesWage && conflict.ChangesWage) {
        this.addToGroup(componentMap, 'Wages', conflict);
      }
      if (this.data.currentChanges.ChangesJobTitle && conflict.ChangesJobTitle) {
        this.addToGroup(componentMap, 'JobTitle', conflict);
      }
      if (this.data.currentChanges.ChangesSupervisor && conflict.ChangesSupervisor) {
        this.addToGroup(componentMap, 'Annex.Supervisor', conflict);
      }
      if (this.data.currentChanges.ChangesTemporaryWorkplace && conflict.ChangesTemporaryWorkplace) {
        this.addToGroup(componentMap, 'Workplace', conflict);
      }
      if (this.data.currentChanges.ChangesWorkingTimeGroup && conflict.ChangesWorkingTimeGroup) {
        this.addToGroup(componentMap, 'WorkingTimeGroupName', conflict);
      }
    });

    componentMap.forEach((conflictingAnnexes, componentName) => {
      this.conflictGroups.push({
        componentName,
        conflictingAnnexes,
      });
    });
  }

  private addToGroup(map: Map<string, ConflictedAnnexesDto[]>, componentName: string, conflict: ConflictedAnnexesDto): void {
    if (!map.has(componentName)) {
      map.set(componentName, []);
    }
    map.get(componentName)!.push(conflict);
  }
}
